import React from "react";
import PropTypes from "prop-types";
import UsernameChangeFormContent from "../components/UsernameChangeFormContent";
import { FormMenu } from "../../../components/Buttons";

import { connect } from "react-redux";
import { updateBasicData } from "../../../redux/actions/auth";
import { loadWorker } from "../../Worker/actions";

const mapStateToProps = null; /* (state) => {
  return {
    user: state.worker.currentWorker,
  };
}; */
const mapDispatchToProps = (dispatch) => ({
  updateData: (...args) => dispatch(updateBasicData(...args)),
  getWorker: (...args) => dispatch(loadWorker(...args)),
});

const UsernameChangeForm = (props) => {
  const { className, user, updateData, getWorker, onClose } = props;
  const formRef = React.useRef(null);

  const onSave = () => {
    const model = formRef.current.getModel();
    if (!model) return;
    console.log(">> updating basic data", model);
    updateData(model, () => {
      onClose();
      getWorker(user);
    });
  };
  const onCancel = () => {
    onClose && onClose();
  };

  return (
    <div className={`${className}`}>
      <UsernameChangeFormContent ref={formRef} model={user} />
      <FormMenu
        className="margin-lg-top w3-border-top pad-big w3-light-grey"
        style={{
          marginLeft: "-1em",
          marginRight: "-1em",
          marginBottom: "-1em",
        }}
        onSave={onSave}
        onCancel={onCancel}
        saveBtnName="updateUsernameBtn"
      />
    </div>
  );
};

UsernameChangeForm.propTypes = {
  className: PropTypes.string,
  user: PropTypes.object,
  updateData: PropTypes.func.isRequired,
  getWorker: PropTypes.func.isRequired,
  onClose: PropTypes.func,
};
UsernameChangeForm.defaultProps = {
  className: "",
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UsernameChangeForm);
